import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Login from "./Pages/Auth/Login";
import VerifyEmail from "./Pages/Auth/VerifyEmail";
import SellerSignup from "./Pages/Auth/SellerSignup";
import ResetPassword from "./Pages/Auth/ResetPassword";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./Pages/Dashboard/Dashboard";
import NotFound from "./Pages/NotFound/NotFound";
import AddProduct from "./Pages/Products/AddProduct";
import EditProduct from "./Pages/Products/EditProduct";
import MyVault from "./Pages/Products/MyVault";
import SellerOrders from "./Pages/SellerOrders/SellerOrders";
import SellerNavbar from "./Components/SellerNavbar/SellerNavbar";
import { account, tablesDB, DB_ID, USERS_TABLE } from "./appwrite";
import SellerOrDet from "./Pages/SellerOrders/SellerOrDet";
import SellerSettings from "./Pages/Settings/SellerSettings";
import LoadingScreen from "./LoadingScreen";
import ScrollToTop from "./ScrollToTop";
import SellerFooter from "./Components/SellerFooter/SellerFooter";
import { useStateValue } from "./StateProvider";

function AppContent() {
  const [, dispatch] = useStateValue();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const location = useLocation();
  const PUBLIC_ROUTES = ["/login", "/signup", "/verify-email", "/reset-password"];
  const isAuthPage = PUBLIC_ROUTES.some((route) =>
    location.pathname.startsWith(route)
  );

  useEffect(() => {
    (async () => {
      try {
        const u = await account.get();
        setUser(u);
        dispatch({ type: "SET_USER", user: u });
        try {
          const doc = await tablesDB.getRow({
            databaseId: DB_ID,
            tableId: USERS_TABLE,
            rowId: u.$id,
          });
          setUserRole(doc.userRole || "seller");
        } catch {
          setUserRole("seller");
        }
      } catch {
        setUser(null);
        setUserRole(null);
        dispatch({ type: "SET_USER", user: null });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <div className="app">
      <ScrollToTop />
      <ToastContainer />
      {!isAuthPage && <SellerNavbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SellerSignup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {user ? (
          <>
            <Route path="/s/order-details/:orderId" element={<SellerOrDet />} />
            <Route path="/s/orders" element={<SellerOrders />} />
            <Route path="/s/my-vault" element={<MyVault />} />
            <Route path="/s/edit-product/:id" element={<EditProduct />} />
            <Route path="/s/add-product" element={<AddProduct />} />
            <Route path="/s/settings" element={<SellerSettings />} />
            <Route path="/" element={<Dashboard />} />
            <Route path="*" element={<NotFound />} />
          </>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
      {!isAuthPage && <SellerFooter />}
    </div>
  );
}

export default function SellerApp() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
